import { createTransport } from "./transportFactory.js";

const { transport, baseUrl } = createTransport("authz");

export const authzTransport = transport;
export const AUTHZ_BASE_URL = baseUrl;
